
















































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import EventsTemplateDetails from "../events/EventsTemplateDetails.vue";

import SettingsJson from "../../shared/SettingsJson";
import EventTemplateJson, { getDuplicateEventTemplateJson } from "../../shared/EventTemplateJson";
import { EventTemplateStatus, EventTemplateStatusNames } from "../../shared/EventTemplateStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "EventsTemplates",
  components: {
    Loading,
    TableView,
    OnscreenMenu,
    EventsTemplateDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      EventTemplateStatus: EventTemplateStatus,
      EventTemplateStatusNames: EventTemplateStatusNames,
      showDetails: false,
      detailsMode: "read",
      useFilters: false as boolean,
      filterStates: [] as EventTemplateStatus[],
      searchString: null as string | null,
      allEventTemplates: null as EventTemplateJson[] | null,
      eventTemplatesMoreAvailable: null as boolean | null,
      selectedEventTemplateId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    openDetails(item: EventTemplateJson | null, mode: string) {
      if (item != null) {
        this.selectedEventTemplateId = item.ID;
      } else {
        this.selectedEventTemplateId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllEventTemplates();
    },

    async loadAllEventTemplates(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.allEventTemplates = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      var states = null as EventTemplateStatus[] | null;
      var skipAmount = null as number | null;

      //filters
      if (this.useFilters) {
        this.filterStates.length > 0 ? (states = this.filterStates) : (states = null);
      }

      //load more
      if (loadMore && this.allEventTemplates != null) {
        this.eventTemplatesMoreAvailable = null;
        skipAmount = this.allEventTemplates.length;
      } else {
        this.allEventTemplates = null;
      }

      if (this.restClient != null) {
        try {
          let eventTemplates = await this.restClient.getEventTemplates(states, this.searchString, skipAmount);

          if (loadMore && this.allEventTemplates != null) {
            this.allEventTemplates = this.allEventTemplates.concat(eventTemplates.eventTemplates);
          } else {
            this.allEventTemplates = eventTemplates.eventTemplates;
          }

          this.eventTemplatesMoreAvailable = eventTemplates.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    reloadData() {
      this.loadAllEventTemplates();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllEventTemplates();
    },

    removeUseFilters() {
      this.useFilters = false;

      this.filterStates = [];
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllEventTemplates();
    },

    resetSearchString() {
      this.searchString = "";

      this.loadAllEventTemplates();
    },

    async duplicateEventTemplate(item: EventTemplateJson) {
      let newItem: EventTemplateJson = getDuplicateEventTemplateJson(item);

      this.allEventTemplates = null;

      try {
        let duplicatedEventTemplate = await this.restClient.addEventTemplate(newItem);
      } catch (e) {
        alert(e.message);
      }

      this.loadAllEventTemplates();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }

      if (button == "duplicateEventTemplate") {
        this.duplicateEventTemplate(item);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    eventTemplateColumns: function (): TableViewColumnDefinitions<EventTemplateJson>[] {
      let vue = this;

      return [
        {
          th: "Vorlage",
          td: (i) => i.title,
        },
        {
          th: "Titel der Veranstaltung",
          td: (i) => i.eventTitle,
        },
        {
          th: "Status",
          td: (i) => vue.EventTemplateStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
        {
          th: "",
          td: (i) => "Duplizieren",
          style: (i) => "text-align:right",
          button: "duplicateEventTemplate",
        },
      ] as TableViewColumnDefinitions<EventTemplateJson>[];
    },
  },
});
